import { LegacyDataProviderRowData } from '@adv-frontend/data-provider';

/**
 * Метод, собирающий общее кол-во подстрок у каждой строки
 * @param rows набор строк
 * @param totalCount запись с количеством подстрок в каждой строке, в которую записывается результат
 */
export function getRowsTotalCount(rows: LegacyDataProviderRowData[], totalCount: Record<string, number>): void {
    for (const row of rows) {
        if (!row.subRows) {
            continue;
        }

        totalCount[row.id] = row.subRows.length;
        getRowsTotalCount(row.subRows, totalCount);
    }
}
